// extracted by mini-css-extract-plugin
module.exports = {"dividerContainer":"Divider_dividerContainer__RZljs","divider":"Divider_divider__XPDUX"};